module.exports = __webpack_public_path__ + "img/6.da5781a0.jpeg";